export default "__VITE_ASSET__BYPyDEA3__"